import _ from "underscore";

import React from "react";
import PropTypes from 'prop-types';
import Toast from "shared/toast";

class RecordingButton extends React.Component {
  constructor() {
    super();
    _.bindAll(this,
      'handleClick'
    );
  }

  componentDidMount() {
    this.props.model.on('change', this.forceUpdate.bind(this, null), this);
    this.props.model.on('change:alertMessage', this._showError.bind(this), this);

    if (this.props.autostart) {
      this.handleClick();
    }
  }

  componentWillUnmount() {
    this.props.model.off('change', null, this);
    this.props.model.off('change:alertMessage', null, this);
  }

  handleClick(evt) {
    this.props.model.handleClick();
    evt && evt.preventDefault();
  }

  _showError() {
    Toast.error({
      title: "Playback Error",
      message: this.props.model.get('alertMessage'),
      sticky: true
    });
  }

  _playIcon() {
    if (this.props.model.get('playText') === 'Loading') {
      return 'access_time';
    } else {
      return this.props.model.get('play') ? 'pause_circle_outline' : 'play_circle_outline';
    }
  }

  render() {
    return (
      <a href='#' className="js-recording-icon" onClick={this.handleClick}>
        <i className="material-icons" data-toggle="tooltip" data-original-title={this.props.model.get('playText')}>
          {this._playIcon()}
        </i>
      </a>
    );
  }
}

RecordingButton.propTypes = {
  model: PropTypes.object.isRequired,
  autostart: PropTypes.bool
};

export default RecordingButton;
